import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import Image from '../ui/Image/Image'
import Card from '../ui/Card/Card'
import Title from '../ui/Title/Title'
import Button from '../ui/Button/Button'
import { getImageUrl, isLanguage } from '../../utils'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

import arrowUpRight from '../../assets/images/arrowUpRight.svg'
import styles from './ServicesCards.module.scss'

const Description = ({ description, classname }) => {
  const { text, image } = description || {}
  return (
    <span className={classNames(styles.description, classname)}>
      <Image
        src={getImageUrl(image)}
        alt={image?.alternativeText}
        className={styles.descriptionImage}
      />
      {text}
    </span>
  )
}

const ServiceCard = ({ cardDetails }) => {
  const { title, description, button } = cardDetails
  const { language } = useLanguage()
  const { isSpanish, isFrench } = isLanguage(language?.code)

  let navigate = useNavigate()

  const handleButtonClick = (details) => {
    navigate(details?.path)
  }
  return (
    <div className={classNames(styles.serviceCardContainer)}>
      <div className={styles.detailsContainer}>
        <div className={styles.textContainer}>
          {/* <Title title={title} classname={styles.title} /> */}
          <Description
            description={description}
            classname={isSpanish || isFrench ? styles['es_description'] : ''}
          />
        </div>
        <Button
          aria-label={button?.label}
          classname={styles.button}
          buttonDetails={button}
          text={button?.label}
          handleClick={handleButtonClick}
        >
          <Image
            src={arrowUpRight}
            alt={`${title} ${button?.label}`}
            className={styles.btnImage}
          />
        </Button>
      </div>
      <div className={styles.imageContainer}>
        <Card className={styles.card}>
          <Image
            src={getImageUrl(cardDetails.cardimage)}
            alt={cardDetails.cardimage?.alternativeText}
            className={styles.cardImageStyle}
          />
        </Card>
      </div>
    </div>
  )
}

function ServicesCards({ widgetDetails: services }) {
  return (
    <div className={styles.servicesContainer}>
      <Title
        title={services[0].title}
        classname={classNames('page-container', styles.title)}
      />
      <div className={classNames('page-container', styles.cardsContainer)}>
        {services.map((item) => (
          <ServiceCard cardDetails={item} key={'servicecard' + item.id} />
        ))}
      </div>
    </div>
  )
}

export default ServicesCards
